/**
 * AudioMetadata 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AudioMetadata
 */
export interface AudioMetadata {
  /** 音频编码(aac/mp3/opus) */
  codec?: string
  /** 音频比特率(bps) */
  bit_rate?: number
  /** 采样率(Hz) */
  sample_rate?: number
  /** 声道数(1/2/6/8) */
  channels?: number
  /** 声道布局(mono/stereo/5.1) */
  channel_layout?: string
}

/**
 * AudioMetadata Schema
 */
export const AudioMetadataSchema: SchemaDefinition = {
  properties: {
    codec: {
      description: '音频编码(aac/mp3/opus)',
      format: '*string',
      type: 'string',
      label: '音频编码',
    },
    bit_rate: {
      description: '音频比特率(bps)',
      format: '*int',
      type: 'integer',
      label: '音频比特率',
    },
    sample_rate: {
      description: '采样率(Hz)',
      format: '*int',
      type: 'integer',
      label: '采样率',
    },
    channels: {
      description: '声道数(1/2/6/8)',
      format: '*int',
      type: 'integer',
      label: '声道数',
    },
    channel_layout: {
      description: '声道布局(mono/stereo/5.1)',
      format: '*string',
      type: 'string',
      label: '声道布局',
    },
  },
  type: 'object',
}
